module.exports = __webpack_public_path__ + "static/media/etc.fc290deb.svg";